<template>
	<div>
		<v-sheet class="mt-10">
			<v-container>
				<div v-if="loading" class="success--text text-h4 text-center">
					در حال دریافت اطلاعات ...
				</div>
				<div v-else>
					<v-alert v-if="errorMessage" type="error" outlined>
						{{ errorMessage }}
					</v-alert>
					<v-slide-x-transition :hide-on-leave="true">
						<v-row v-if="loan">
							<v-col cols="12" md="12" class="text-center">
								<img :src="loan.base64 ? loan.base64 : '/jetaqsaat-loan-plan.webp'" style="max-width: 100%;" />
							</v-col>
							<v-col cols="12">
								<v-card elevation="5">
									<v-row>
										<v-col cols="12">
											<h1 class="orange--text text--darken-2 ff-emkan-bold fs-h3 text-center">{{ loan.title }}</h1>
										</v-col>
									</v-row>
									<v-row>
										<v-col cols="4">
											<div class="d-flex justify-end">
												<v-icon color="secondary">mdi-percent-circle</v-icon>
												درصد بهره: <span class="secondary--text">{{ loan.profitPercent }}</span>
											</div>
										</v-col>
										<v-col cols="4" class="">
											<div class="d-flex justify-center">
												<v-icon color="secondary">mdi-alert-circle</v-icon>
												جریمه دیرکرد: <span class="secondary--text">{{ loan.delayPercent ? 'دارد' : 'ندارد' }}</span>
											</div>
										</v-col>
										<v-col cols="4" class="">
											<div class="d-flex justify-start">
												<v-icon color="secondary">mdi-arrow-down-circle</v-icon>
												سود زودکرد: <span class="secondary--text">{{ loan.earlyPercent ? 'دارد' : 'ندارد' }}</span>
											</div>
										</v-col>
									</v-row>
									<v-row>
										<v-col cols="12" class="text-center">
											مدارک اولیه مورد نیاز:
											<span class="secondary--text" v-if="!authorizations.length">ندارد</span>
											<v-badge v-else v-for="authorize in authorizations" :key="authorize.id" color="secondary" :content="authorize.title" inline>
											</v-badge>
											<v-badge v-if="secondaryAuthorization" color="secondary" :content="secondaryAuthorization" inline></v-badge>
										</v-col>
									</v-row>
								</v-card>
							</v-col>
							<v-col cols="12" md="12">
								<div v-html="loan.planHtml" class="mt-5"></div>
							</v-col>
						</v-row>
					</v-slide-x-transition>
				</div>
			</v-container>
		</v-sheet>

		<v-sheet color="#f5f5f5" class="py-15 mt-15 px-5" v-if="loan">
			<div style="max-width: 750px;" class="mx-auto mb-5">
				<div class="line-title mt-5">
					<span class="text">درخواست خود را ثبت کنید</span>
					<span class="line"></span>
				</div>
				<div class="mt-7">
					<v-row class="justify-center">
						<v-col cols="12" md="6">
							<div class="price-table" style="background-color: #fff">
								<div class="header">
									<div class="title-2">مبلغ وام و تعداد اقساط را انتخاب کنید:</div>
								</div>

								<div class="features">
									<loan-calculator id="calculator" v-model="loanRequest" :payableColor="'orange'" class="mt-3" />
									<div class="mt-5 pb-5 text-center">
										<div v-if="loan.disable" class="red--text pa-2">
											{{ loan.disableText ? loan.disableText : 'این نوع وام در حال حاضر غیرفعال می باشد.' }}
										</div>
										<v-btn v-else class="rounded-xl" :loading="submitRequestLoading" color="secondary" elevation="5" @click="submitRequest">
											ثبت درخواست
										</v-btn>
									</div>
									<v-alert type="error" outlined v-if="loanRequestMessage">
										{{ loanRequestMessage }}
									</v-alert>
								</div>
							</div>
						</v-col>
					</v-row>
				</div>
			</div>
		</v-sheet>
	</div>
</template>

<script>
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import router from '@/router'
	import { emptyId } from '@/util/emptyId'

	export default {
		name: 'PlanView',
		components: {
			'loan-calculator': () => import('@/components/LoanCalculator'),
		},
		data: () => ({
			errorMessage: '',
			loanRequest: { amount: 10000000, installmentCount: 1, monthGap: 1, loanModel: null },
			loan: null,
			customerCode: 0,
			code: 0,
			loading: false,
			submitRequestLoading: false,
			loanRequestMessage: ''
		}),
		computed: {
			...get('auth', [
				'isMember', 'getCurrentUser'
			]),
			authorizations() {
				return this.loan?.loanAuthorizationItems?.filter(x => x.isPrimary)?.map(x => x.authorizationItem) || []
			},
			secondaryAuthorization() {
				if (this.loan?.loanAuthorizationItems?.some(x => !x.isPrimary))
					return 'سایر مدارک پس از ارزیابی'
				return ''
			}
		},
		mounted() {
			this.customerCode = this.$route.params.customerCode || 0
			this.code = this.$route.params.code || 0
			this.loadLoan()
		},
		methods: {
			loadLoan() {
				if (!this.customerCode || !this.code) {
					this.errorMessage = 'پارامترهای مورد نیاز یافت نشدند.'
					return
				}
				this.loading = true
				return api.get(`loan/get/${this.customerCode}/${this.code}`, null, { authHeader: false, contentType: 'application/json' })
					.then(
						response => {
							this.loan = response
							this.loanRequest.loanModel = this.loan
						})
					.catch(err => {
						this.errorMessage = err.message
					})
					.finally(() => {
						this.loading = false
					})
			},
			submitRequest() {
				if (!this.loan) {
					this.loanRequestMessage = 'طرح وام انتخاب نشده است. لطفا از صفحه خانه سایت مراحل انتخاب طراح وام را طی نمایید.'
					return
				}
				if (!this.isMember) {
					window.localStorage.setItem("loanrequest", JSON.stringify(this.loanRequest))
					router.push({ name: 'Register', params: { customerCode: this.customerCode } }).catch(() => { })
					return
				}
				this.submitRequestLoading = true
				this.loanRequestMessage = ''
				api.post('member/userLoanRequest/create', this.loanRequest)
					.then(response => {
						router.replace('/member/LoanRequest/' + response).catch(() => { })
					})
					.catch(err => {
						this.loanRequestMessage = err.message
					})
					.finally(() => {
						this.submitRequestLoading = false
					})
			},
		},
	}
</script>

<style lang="scss">
	.landing {
		.fs-h1 {
			font-size: 3.3125rem !important;
		}

		.fs-h2 {
			font-size: 2.25rem !important;
		}

		.fs-h3 {
			font-size: 1.5625rem !important;
		}

		.fs-h4 {
			font-size: 1.125rem !important;
		}

		.fs-h5 {
			font-size: 1.0625rem !important;
		}

		.fs-h6 {
			font-size: 0.75rem !important;
		}

		.fs-subtitle-1 {
			font-size: 0.875rem !important;
		}

		.fs-subtitle-2 {
			font-size: 0.875rem !important;
		}

		.fs-caption {
			font-size: 0.8125rem !important;
		}
	}

	.section-title {
		position: relative;
		margin-right: 38px;

		&:before {
			position: absolute;
			bottom: 5px;
			right: -40px;
			content: "";
			width: 30px;
			height: 60px;
			background-image: radial-gradient(#bbb 2px, transparent 2px);
			-webkit-background-size: 20px 20px;
			background-size: 10px 10px;
			border-radius: 0px;
			background-repeat: initial;
		}
	}

	.line-title {
		position: relative;
		display: flex;

		.line {
			position: relative;
			flex-grow: 2;

			&:after {
				position: absolute;
				content: " ";
				background-color: #cdcdcd47;
				height: 2px;
				right: 0;
				left: 0;
				top: 25px;
			}
		}

		.text {
			padding-left: 20px;
			font-size: 2.25rem !important;
			color: orange;
			font-family: "Emkan-Bold", "Yekan", "tahoma";
		}

		&:after {
			height: 2px;
			width: 50px;
			content: "";
			position: absolute;
			left: 0;
			height: 2px;
			top: 46%;
			background-color: orange;
		}
	}

	.price-table {
		background-color: #f1f1f1;
		position: relative;

		.price-table__ribbon {
			position: absolute;
			top: 0;
			left: 0;
			right: auto;
			-webkit-transform: rotate(0);
			-ms-transform: rotate(0);
			transform: rotate(0);
			width: 150px;
			overflow: hidden;
			height: 150px;

			.price-table__ribbon-inner {
				background-color: orange;
				color: #ffffff;
				font-weight: 500;
				text-align: center;
				left: 0;
				width: 200%;
				-webkit-transform: translateY(-50%) translateX(0) translateX(35px) rotate(-45deg);
				-ms-transform: translateY(-50%) translateX(0) translateX(35px) rotate(-45deg);
				transform: translateY(-50%) translateX(0) translateX(35px) rotate(-45deg);
				margin-top: 35px;
				font-size: 13px;
				line-height: 2;
			}
		}

		.header {
			background-color: #4d306e;
			text-align: center;
			padding: 20px;

			.title-1 {
				font-size: 1.4rem;
				font-weight: bold;
				color: white;
			}

			.title-2 {
				font-size: 0.9rem;
				color: white;
			}
		}

		.price {
			padding: 15px;
			// font-family: "Emkan-Bold", "Yekan", "tahoma";
			font-size: 3rem;
			text-align: center;

			.currency {
				font-size: 1rem;
			}
		}

		.features {
			margin: 0 25px;
			min-height: 320px;
			padding-top: 10px;

			.features-item {
				display: flex;
				justify-content: space-between;
				padding: 10px;
				border-bottom: 1px solid rgba(122, 122, 122, 0.298);
				color: #7a7a7a;
				font-size: 0.9rem;
				transition: all 0.3s;
				cursor: pointer;

				.selected {
					border: 1px solid blue;
				}

				&:hover {
					color: #fff !important;
					background-color: #4d306e;
				}
			}
		}
	}
</style>